<template>
  <b-row>
    <StepperCol :step="4" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        工事費込みのエアコンですか？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{
            a0Selected ? "工事費込み" : "工事費別"
          }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : "" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-form-row>
          <b-col cols="12" md="4" class="mb-2">
            <b-button
              class="btn-gd text-left p-0 h-120px"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <b-row no-gutters class="h-100">
                <h6 class="h4 pt-3 pl-3">工事費込商品を購入</h6>
                <b-col
                  cols="6"
                  class="pt-2 pb-3 pl-3 d-flex flex-column justify-content-between"
                >
                  <dl class="text-muted mb-0">
                    <dt>工事費用</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="pt-md-2 pb-3">
                  <b-img
                    :src="require('@/assets/images/q-4-1.png')"
                    fluid
                  ></b-img>
                  <div class="pr-3 text-right text-primary">
                  </div>
                </b-col>
              </b-row>
            </b-button>
            
          </b-col>

          <b-col cols="12" md="4" class="mb-2">
            <b-button
              class="btn-gd text-left p-0 h-120px"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <b-row no-gutters class="h-100">
                <h6 class="h4 pt-3 pl-3">工事費別の商品を購入</h6>
                <b-col
                  cols="6"
                  class="pt-2 pb-3 pl-3 d-flex flex-column justify-content-between"
                >
                  <!-- <dl class="text-muted mb-0">
                    <dt>工事費</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl> -->
                </b-col>
                <b-col cols="6" class="pt-2 pb-3">
                  <b-img
                    :src="require('@/assets/images/q-4@2x.png')"
                    fluid
                  ></b-img>
                  <div class="pr-3 text-right text-primary">
                  </div>
                </b-col>
              </b-row>
            </b-button>
            
          </b-col>
        </b-form-row> 
        
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 4) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = true;
      }
      this.doSaveAnswer({ keyword: 'has_construction', answer: value });
      if (value == 0) {
        this.doUpdateStep(6);
        this.doSaveAnswer({ keyword: 'aircon_type', answer: 3 }); // 工事費込み商品を購入
      } else {
        this.doUpdateStep(5);
      }
      this.shrinking = true;
    },
  },
};
</script>